import { Screen, Icon, Text, ProfileSkeleton, BackButton } from '@components'
import { useTheme } from '@react-navigation/native'
import React, { useState } from 'react'
import { ScrollView, View } from 'react-native'
import { ScreenProfileProps } from 'src/navigation/navigator/ProfileNavigator'
import { ProfileImage } from './components'
import getStyle from './style'
import { Memories, Notes, Reminders } from '../../components/organisms'
import { About, GhostActionButtons } from '../contacts/detailsGhostProfile/components'
import { CalendarEvent, useCreationStackIntegration, useGetProfile, useScreen } from '@hooks'

export const Profile: React.FC<ScreenProfileProps<'ProfileHome'>> = ({}) => {
  const theme = useTheme()
  const styles = getStyle(theme)
  const { isMobile, isWeb } = useScreen()
  const { data: profile, isFetching } = useGetProfile()
  const { isCreationStackEnabled, showReminderCreation, showNoteCreation } =
    useCreationStackIntegration()

  const [selectedTab, setSelectedTab] = useState<'about' | 'note' | 'reminder' | 'memory'>('about')

  const handleEventPress = (event: CalendarEvent) => {
    showReminderCreation({
      isCreationStack: true,
      eventId: event.id,
    })
  }

  const handleNotePress = (noteId: string) => {
    showNoteCreation({
      isCreationStack: true,
      noteId: noteId,
    })
  }

  return isFetching ? (
    <Screen>
      <ProfileSkeleton />
    </Screen>
  ) : (
    <Screen>
      {!isWeb && <BackButton noOffset />}
      <ScrollView
        contentContainerStyle={styles.contentContainer}
        showsVerticalScrollIndicator={false}
      >
        <View style={styles.content}>
          <View style={styles.infoContainer}>
            <ProfileImage profileId={profile?.id} isMe avatarUrl={profile?.avatarUrl} />
            <View style={styles.rightContainer}>
              <View style={styles.titleContainer}>
                <Text type="titleBold" style={styles.name}>
                  {profile?.fullName}
                </Text>
              </View>
              <Text type="body" color={theme.colors.primary} style={styles.work}>
                {profile?.contacts?.email ||
                  profile?.contacts?.phone ||
                  profile?.contacts?.website ||
                  profile?.contacts?.facebook ||
                  profile?.contacts?.instagram ||
                  profile?.contacts?.twitter ||
                  profile?.contacts?.linkedin}
              </Text>
              <View style={styles.row}>
                {(profile?.professions || []).length > 0 && (
                  <View style={styles.locationContainer}>
                    <Icon
                      name="work"
                      size={theme.iconSize.extraSmall}
                      color={theme.colors.greyBlue}
                    />
                    <Text
                      type="body"
                      color={theme.colors.greyBlue}
                      style={styles.locationText}
                      numberOfLines={1}
                      ellipsizeMode="tail"
                    >
                      {profile?.professions.map((p) => p.name).join(' & ')}
                    </Text>
                  </View>
                )}
                {profile?.residence && (
                  <View style={styles.locationContainer}>
                    <Icon
                      name="mapPin"
                      size={theme.iconSize.extraSmall}
                      color={theme.colors.greyBlue}
                    />
                    <Text
                      type="body"
                      color={theme.colors.greyBlue}
                      style={styles.locationText}
                      numberOfLines={1}
                      ellipsizeMode="tail"
                    >
                      {profile?.residence?.name ?? profile?.residence?.nameFr}
                    </Text>
                  </View>
                )}
              </View>
            </View>
          </View>
          <GhostActionButtons
            contact={profile!}
            /*onNotesPress={() => (navigation as any).navigate('Menu', {screen: 'Notes'})}*/ selectedTab={
              selectedTab
            }
            setSelectedTab={setSelectedTab}
          />
          <View style={!isMobile && styles.container}>
            {selectedTab === 'about' && <About profile={profile} />}
            {selectedTab === 'note' && profile && (
              <Notes
                profileId={profile.id}
                onNotePress={isCreationStackEnabled ? handleNotePress : undefined}
              />
            )}
            {selectedTab === 'reminder' && (
              <Reminders
                withAddButton
                onEventPress={isCreationStackEnabled ? handleEventPress : undefined}
              />
            )}
            {selectedTab === 'memory' && <Memories profileId={profile!.accountId} />}
          </View>
        </View>
      </ScrollView>
    </Screen>
  )
}
